module.exports = __webpack_public_path__ + "img/pr-9.aa51d708.png";